import { request } from '@/utils'
import { apiBaseUrl, cartApiPath, SHOP_ID } from '@/utils/const'
import { actUrl, homePageUrl } from './const'
import flat from './flat'

// 针对本次，app 外的使用 report_event_without_login，其他的依旧使用 report_event
const isApp = /bcz_app_([a-zA-Z]+)(_[a-zA-Z]+)?\/(\d*\.?\d*)/.test(navigator.userAgent)
const url = isApp
  ? 'https://system.baicizhan.com/api/system/report_event'
  : 'https://system.baicizhan.com/api/system/report_event_without_login'

const stat_group = 'bcz_mall-common'

/**
 * 上报数据接口
 * 1s钟之内必定会resolve 或者 reject，防止跳转失效
 * @param {Object} options 事件数据对象
 * {
 *  product_id: 'bcz_app_h5',
 *  stat_group: 事件所属组
 *  event_id: 事件的名称
 * }
 */
export function reportEvent(options) {
  return Promise.race([
    sleepTime(1000),
    request(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain',
      },
      body: [
        {
          log_time: new Date().getTime(),
          product_id: 'bcz_app_h5',
          stat_group: stat_group,
          ...options,
        },
      ],
    }),
  ])
}

function sleepTime(ms) {
  return Promise.resolve(resolve => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
}

/**
 * get_today_super_discount
 */

export function fetchTodayDiscount() {
  //apiBaseUrl
  return request(`${homePageUrl}/get_today_super_discount?shopId=${SHOP_ID}`)
}

/**
 * 获取 “猜你喜欢的内容”
 */
export function fetchRecommend() {
  //apiBaseUrl
  return request(`${cartApiPath}/get_recommand_goods?shopId=${SHOP_ID}`)
}

export function fetchRecommendBooks() {
  return request(`${homePageUrl}/get_recommend_books`)
}

/**
 * 获取商品的详情，最多支持10个商品的批量查询
 * @param {Array} ids []
 */
export function fetchProducts(ids = []) {
  const idsStr = ids.slice(0, 10).join(',')
  return request(`${homePageUrl}/get_goods_info_by_ids?itemIds=${idsStr}&shopId=${SHOP_ID}`)
}

/**
 * 获取购物车相关信息
 */
export function fetchCart() {
  return request(`${cartApiPath}/get_cart_sku_count?shopId=${SHOP_ID}`)
}

export function getDailyReward() {
  return request(`${homePageUrl}/get_daily_reward`)
}

///api/mall/proxy/homepage/get_home_page_info

export function getHomePageInfo() {
  return request(`${homePageUrl}/get_home_page_info`)
}

export function getNewUserCredit() {
  return request(`${homePageUrl}/get_new_user_credit`)
}

export function fetchSkeleton(trace) {
  // return request('https://learn.baicizhan.com/api/mall/proxy/index_info')
  const p = trace ? `?trace=${trace}` : ''
  return request(`${apiBaseUrl}/index_info${p}`)
}

export function sendGift(activityId = 10005, shopId = SHOP_ID) {
  return flat(`${homePageUrl}/send_gift?activityId=${activityId}&shopId=${shopId}`)
}

//新人弹层
export function fetchActivityInfo(activityId = 10005, shopId = SHOP_ID) {
  // https://learn.baicizhan.com/api/mall/proxy/homepage/get_user_activity_info?activityId=10005&shopId=1
  return flat(`${homePageUrl}/get_user_activity_info?activityId=${activityId}&shopId=${shopId}`)
}

//双11 活动信息
export function fetchDoubleActInfo(activityId = 10006, shopId = SHOP_ID) {
  return flat(`${actUrl}/get_user_activity_info?activityId=${activityId}&shopId=${shopId}`)
}

//发放赠品
export function sendGiftNew(activityId = 10006, shopId = SHOP_ID) {
  return flat(`${actUrl}/send_gift?activityId=${activityId}&shopId=${shopId}`)
}

//老用户领取优惠券
export function getCouponOld() {
  return flat(`${actUrl}/old_user_send_coupon`)
}

//用户抽奖
export function lottery(orderId) {
  return flat(`${actUrl}/lottery?orderId=${orderId}`)
}

export function getWinUsers() {
  return flat(`${actUrl}/get_win_gift_user`)
}

/**
 * 获取购物车相关信息
 */
export function getHomePageActivity() {
  return request(`${actUrl}/get_home_page_activity`)
}

///homepage/get_recommend_goods_by_page

//H3组件接口
export function getRecommandGoodsByPage(param) {
  const { pageIndex, pageSize = 60, scenesId = 1, shopId = SHOP_ID } = param
  return flat(`${homePageUrl}/get_recommend_goods_by_page`, {
    method: 'POST',
    body: {
      shopId,
      pageIndex,
      pageSize,
      scenesId,
    },
  })
}

//C2组件接口
///api/mall/proxy/homepage/get_c2_list

export function getC2List() {
  return flat(`${homePageUrl}/get_c2_list`)
}

export function getA4Data() {
  return flat(`${homePageUrl}/get_home_banner`)
}
